<template>
	<div class="t-page_courses t-work-area">
		<h1>{{ pageText.title }}</h1>
		<div class="t-work-area__row">
			<div class="t-work-area__column_big">
				<div class="t-work-area__cell t-work-area__cell_small">
                    <cmp-search :type="'full'"></cmp-search>
				</div>
                <cmp-banner></cmp-banner>
                <cmp-promo-courses 
                    :text="{title:pageText.title_4}"
                    :swiper="false"
                    :items="recommendations.courses">
                </cmp-promo-courses>
				<cmp-courses-list :type="'all'"></cmp-courses-list>
			</div>
            <cmp-promo-teachers  class="t-work-area__column_small"
                :text="{title:pageText.teacher, promoBtn: pageText.promoBtn}"
                :swiper="false"
                :items="recommendations.teachers">
            </cmp-promo-teachers>
		</div>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/coursesPage.json' : 'staticText',
        main: {
            title: 'Уроки, курсы и консультации',
            course: 'Рекомендуемый курс',
            teacher: 'Рекомендуемый учитель',
            promoBtn: 'Заказать рекламу'
        }
    };

    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    // import Course from '../../vue_components/Course.vue'
    // import Teacher from '../../vue_components/Teacher.vue'
    import CoursesList from '../../vue_components/CoursesList.vue'    
    import PromoTeachers from '../../vue_components/PromoTeachers.vue'
    import PromoCourses from '../../vue_components/PromoCourses.vue'

    import Banner from '../../vue_components/Banner.vue'

	export default {
        data(){
            return {
                pageText: {}
			}
        },
        components: {
            'cmp-courses-list': CoursesList,
            // 'cmp-course': Course,
            // 'cmp-teacher': Teacher,
            'cmp-promo-teachers': PromoTeachers,
            'cmp-promo-courses': PromoCourses,
            'cmp-banner': Banner,
        },
        computed: {
            ...mapGetters('recommendations', ['recommendations'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load(pageText){
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate (to, from, next) {
            store.dispatch('coursesList/LoadCourses', to.query).then(() => {
                next()
            });
        },
        beforeRouteEnter (to, from, next) {
            let props = {};
            for(let key in to.query){
                props[key] = to.query[key]
						}
            if(props.page === undefined)
                props.page = 1;

            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });

            store.dispatch('coursesList/LoadCourses', props).then(() => {
                count++;
                RunNext();
            });
            store.dispatch('recommendations/LoadRecommendations').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadTopics').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('handbook/LoadBannerType').then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if(count > 4)
                    next(vm => vm.Load(pageText))
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/vue_pages/Courses/Index.vue